import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import 'es6-shim';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import 'reflect-metadata';
import { routing } from './app-module.routing';
import { AppComponent } from './app.component';
import { ExternalUserAuthGuard } from './auth/guards/external-user-auth-guard.service';
import { PetOwnerAuthGuard } from './auth/guards/pet-owner-auth-gurad.service';
import { PreventLoadingSecondaryViewGuard } from './auth/guards/prevent-loading-secondary-view.service';
import { RouteGuard } from './auth/guards/route-guard';
import { StaffAuthGuard } from './auth/guards/staff-auth-guard.service';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { GlobalInterceptor } from './shared/utilities/globalInterceptor';
import { SecurityService } from './shared/utilities/security.service';

import { StoreModule } from '@ngrx/store';
import { RegistrationFormReducer } from './reducers/registrationform.reducer';
import { AddressReducer } from './reducers/address.reducer';
import { ImplanterReducer } from './reducers/implanter.reducer';
import { environment } from 'src/environments/environment';
import { NgOtpInputModule } from  'ng-otp-input';
import { ChangeOwnershipRequestsComponent } from './change-ownership-requests/change-ownership-requests.component';
import { ChangeOwnershipReducer } from './reducers/change-ownership.reducer';
import { ChangeOwnershipNewOwnerReducer } from './reducers/change-ownership-new-owner.reducer';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    ChangeOwnershipRequestsComponent,
  ],
  imports: [
    routing,
    BrowserModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    LoadingBarHttpClientModule,
    NgxUiLoaderModule,
    NgOtpInputModule,
    StoreModule.forRoot({registrationForm: RegistrationFormReducer, address: AddressReducer, implanter: ImplanterReducer, changeOwnership: ChangeOwnershipReducer,changeOwnershipNewOwner: ChangeOwnershipNewOwnerReducer})
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: GlobalInterceptor, multi: true },
    SecurityService,
    StaffAuthGuard,
    RouteGuard,
    ExternalUserAuthGuard,
    PetOwnerAuthGuard,
    PreventLoadingSecondaryViewGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
